import React from 'react'
import { Grid } from "@mui/material";
import { PostType } from '../../../types';
import { useStyles } from "./PostCotent.styles";

interface PostContentProps {
	post: PostType
}

export function PostContent({ post }: PostContentProps) {
	const { classes } = useStyles()

	return (
		<section className={classes.root}>
			<Grid container className={classes.container}>
				<Grid item xs={12}>
					<div
						className={classes.content}
						dangerouslySetInnerHTML={{ __html: post?.postBody || post?.rssBody || 'Sin contenido' }}
					/>
				</Grid>
			</Grid>
		</section>
	)
}